import { FeeAmount } from 'elephantswapv3-sdk'

const FEE_TIERS = [FeeAmount.LOWEST, FeeAmount.LOW, FeeAmount.MEDIUM, FeeAmount.HIGH]

export function getOnChainFeeTierPercentages(
  existingFeeTiers: FeeAmount[],
  liquidities: Partial<Record<FeeAmount, number>>
): Record<FeeAmount, number | undefined> | undefined {
  if (!existingFeeTiers.length) return undefined

  const totalLiquidity = existingFeeTiers.reduce(
    (total, feeAmount) => total + Math.max(0, liquidities[feeAmount] ?? 0),
    0
  )
  const useEqualWeights = totalLiquidity === 0
  const denominator = useEqualWeights ? existingFeeTiers.length : totalLiquidity

  return FEE_TIERS.reduce((percentages, feeAmount) => {
    percentages[feeAmount] = existingFeeTiers.includes(feeAmount)
      ? ((useEqualWeights ? 1 : Math.max(0, liquidities[feeAmount] ?? 0)) / denominator) * 100
      : undefined
    return percentages
  }, {} as Record<FeeAmount, number | undefined>)
}

export function formatCompactTVL(value: number | undefined): string {
  if (value === undefined || !Number.isFinite(value)) return 'TVL pending'

  const absoluteValue = Math.abs(value)
  const units = [
    { minimum: 1e9, suffix: 'B' },
    { minimum: 1e6, suffix: 'M' },
    { minimum: 1e3, suffix: 'K' },
  ]
  const unit = units.find(({ minimum }) => absoluteValue >= minimum)
  const scaledValue = unit ? value / unit.minimum : value
  const maximumFractionDigits = unit ? 1 : absoluteValue < 100 ? 2 : 0
  const formatted = scaledValue.toLocaleString('en-US', { maximumFractionDigits })

  return `$${formatted}${unit?.suffix ?? ''} TVL`
}
